const appConfig = {
    apiPrefix: '/api',
    apiReportsPrefix: '/api',
    apiPrefixServer: 'https://api.sanchezp.law/api',
    //apiPrefixServer: 'http://localhost:3050/api',  
    apiReportsServer: 'https://reports.sanchezp.law/api', //https://localhost:44351/api, https://reports.sanchezp.law/api, http://localhost:49510/
    AZURE_STORAGE_CONNECTION_STRING: "DefaultEndpointsProtocol=https;AccountName=sanchezplaw;AccountKey=a1szZ/qwSS+ArD4MUABsK5hLkI8ozQSMTclHHjhgmuBTy6/TEVMC9NAnK5dreqdP/KGYJ5s05WaN+AStZZ8zMw==;EndpointSuffix=core.windows.net",
    AZURE_containername:"sanchezplawcontainer",
    storageAccountName: "sanchezplaw",
    sasToken: "sp=racwdli&st=2025-05-19T23:12:54Z&se=2045-05-20T07:12:54Z&sv=2024-11-04&sr=c&sig=nBhVdWDsLk9%2B1Fi4xpdBYHkifuBkbH9mhpzdTHVDRdE%3D",
    unAuthenticatedEntryPath: '/sign-in',
    authenticatedEntryPath: '/pages/welcome' ,
    tourPath: '/app/account/kyc-form',
    enableMock: true
}

export default appConfig